import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { LabelValueComponent } from '@howdeniberia/core-front';
import { IClientDto } from './../../core/models/client.dto';

@Component({
  selector: 'howden-client-extra-info',
  templateUrl: './client-extra-info.component.html',
  styleUrls: ['./client-extra-info.component.scss'],
  imports: [LabelValueComponent, MatDialogModule, MatIcon, MatButton]
})
export class ClientExtraInfoComponent {
  dialogRef = inject<MatDialogRef<ClientExtraInfoComponent>>(MatDialogRef);
  private data = inject<IClientDto>(MAT_DIALOG_DATA);

  client: IClientDto = {} as IClientDto;

  constructor() {
    const data = this.data;

    this.client = data;
  }

  close() {
    this.dialogRef.close();
  }
}
